import React, { FC } from "react";
import classNames from "classnames/dedupe";

import {
  AccordionDetails,
  AccordionItem,
  Button,
  Column,
  Divider,
  AccordionTitleWithIcon,
  FooterList,
  Link,
  Row,
  LinkList,
} from "../../components";
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
} from "../../icons";
import { listData, checkoutFooterLinks } from "../../mock/footer";
import ShortFooter from "./ShortFooter";

export interface IFooterProps {
  /**
   * Changes footer view if prop is provided
   */
  isCheckout?: boolean;
}

const Footer: FC<IFooterProps> = ({ isCheckout = false }) => {
  const socialMediaLinks = (
    <div className="mb-lg-8 mt-lg-11">
      <div className="footer-heading">Follow us</div>
      <div className="d-flex">
        <Link href="/">
          <Button
            variant="largeIcon"
            size="large"
            classes={{
              root: "text-color-blue uds-zoom uds-zoom-in-hover me-4",
            }}
          >
            <InstagramIcon />
          </Button>
        </Link>
        <Link href="/">
          <Button
            variant="largeIcon"
            size="large"
            classes={{
              root: "text-color-blue uds-zoom uds-zoom-in-hover me-4",
            }}
          >
            <FacebookIcon />
          </Button>
        </Link>
        <Link href="/">
          <Button
            variant="largeIcon"
            size="large"
            classes={{
              root: "text-color-blue uds-zoom uds-zoom-in-hover me-4",
            }}
          >
            <YoutubeIcon />
          </Button>
        </Link>
        <Link href="/">
          <Button
            variant="largeIcon"
            size="large"
            classes={{
              root: "text-color-blue uds-zoom uds-zoom-in-hover me-4",
            }}
          >
            <TwitterIcon />
          </Button>
        </Link>
      </div>
    </div>
  );
  return (
    <footer className="footer">
      <Divider size="bold" classes={{ root: "my-0" }} />
      <Row
        classes={{
          root: classNames("mt-8", { "align-items-end": isCheckout }),
        }}
      >
        {/* Contact and social info */}
        <Column xs={12} lg={4}>
          <div className={isCheckout ? "mb-0 mb-lg-8" : "mb-8"}>
            <div className="footer-heading mb-4 mb-lg-6">Contact us</div>
            <div className="footer-email">
              <Link
                href="mailto:Customersupport@intersport.com"
                text="Customersupport@intersport.com"
                classes={{ root: "footer-email__link" }}
              />
            </div>
          </div>
          {!isCheckout && socialMediaLinks}
        </Column>
        {/* Contact and social info */}

        {/* Desktop Link List sections */}
        <Column xs={12} lg={8} classes={{ root: "mb-lg-8" }}>
          <Row classes={{ root: "d-none d-lg-flex" }}>
            {!isCheckout ? (
              listData.map((item) => (
                <Column key={item.title} xs={3}>
                  <FooterList titleText={item.title} linksItems={item.links} />
                </Column>
              ))
            ) : (
              <Column xs={9}>
                <LinkList
                  classes={{
                    root: "list-unstyled p-0 m-0 d-flex justify-content-between",
                    link: "text-regular text-decoration-none",
                  }}
                  linksItems={checkoutFooterLinks}
                />
              </Column>
            )}
          </Row>
        </Column>
      </Row>

      <Divider classes={{ root: "d-md-none mt-8" }} />

      <Row classes={{ root: "d-md-none" }}>
        <Column>
          <AccordionItem
            isExpanded
            classes={{
              root: "filter-accordion filter-accordion--light footer-acc",
            }}
          >
            <AccordionTitleWithIcon>Help</AccordionTitleWithIcon>
            <AccordionDetails>
              <FooterList
                fontVariant="medium"
                linksItems={[
                  { text: "Delivery", href: "#" },
                  { text: "Returns", href: "#" },
                  { text: "Payment options", href: "#" },
                  { text: "Size guide", href: "#" },
                  { text: "FAQ’s", href: "#" },
                  { text: "Contact Us", href: "#" },
                  { text: "Find a store", href: "#" },
                ]}
              />
            </AccordionDetails>
          </AccordionItem>

          <AccordionItem
            classes={{
              root: "filter-accordion filter-accordion--light footer-acc",
            }}
          >
            <AccordionTitleWithIcon>About</AccordionTitleWithIcon>
            <AccordionDetails>
              <FooterList
                linksItems={[
                  { text: "About us", href: "#" },
                  { text: "Press", href: "#" },
                  { text: "Join us", href: "#" },
                  { text: "Our Stores", href: "#" },
                  { text: "Blog", href: "#" },
                ]}
              />
            </AccordionDetails>
          </AccordionItem>

          <AccordionItem
            classes={{
              root: "filter-accordion filter-accordion--light footer-acc",
            }}
          >
            <AccordionTitleWithIcon>Services</AccordionTitleWithIcon>
            <AccordionDetails>
              <FooterList
                linksItems={[
                  { text: "Bike analysis & adjustment", href: "#" },
                  { text: "Bikeservice", href: "#" },
                  { text: "Bootfitting", href: "#" },
                  { text: "E-bike insurance", href: "#" },
                  { text: "Guarantee services", href: "#" },
                  { text: "Gift card", href: "#" },
                  { text: "Test & Buy", href: "#" },
                ]}
              />
            </AccordionDetails>
          </AccordionItem>
        </Column>
      </Row>
      <ShortFooter />
    </footer>
  );
};

export default Footer;
